import { Button as ButtonAntD, Input as InputAntD } from 'antd';
import { Link as LinkRouter } from 'react-router-dom';
import styled from 'styled-components';

export const Div = styled.div`
  .ant-table-cell {
    font-family: -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "apple color emoji", "segoe ui emoji", "Segoe UI Symbol", "noto color emoji";
  }

  padding: 24px 24px 70px;

  .ant-pagination-item-active,
  .ant-pagination-item:focus,
  .ant-pagination-item:hover {
    border-color: ${({ theme }) => theme.primary};
    a {
      color: ${({ theme }) => theme.primary};
    }
  }

  .ant-pagination-item,
  .ant-pagination-item-link,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 3px;
  }

  .ant-pagination-prev:focus
  .ant-pagination-item-link,
  .ant-pagination-next:focus
  .ant-pagination-item-link,
  .ant-pagination-prev:hover
  .ant-pagination-item-link,
  .ant-pagination-next:hover
  .ant-pagination-item-link {
    border-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};
  }

  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: ${({ theme }) => theme.primary};
  }

  &:focus {
    box-shadow: 0 0 2px ${({ theme }) => theme.primary};
  }

  .ant-select.ant-pagination-options-size-changer.ant-select-single.ant-select-show-arrow.ant-select-focused .ant-select-selector {
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    box-shadow: 0 0 2px ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-select-item-option-selected {
    background-color: ${({ theme }) => theme.hoveredDiv};
  }

  .ant-pagination-jump-prev
  .ant-pagination-item-container
  .ant-pagination-item-link-icon,
  .ant-pagination-jump-next
  .ant-pagination-item-container
  .ant-pagination-item-link-icon {
    color: ${({ theme }) => theme.primary};
  }
`;

export const Link = styled(LinkRouter)`
  color: ${({ theme }) => theme.primary};

  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const Input = styled(InputAntD)`
  &:hover, &:focus {
    border-color: ${({ theme }) => theme.primary};
  }

  &:focus {
    box-shadow: 0 0 2px ${({ theme }) => theme.primary};
  }
`;

export const Title = styled.h1`
  display: flex;
  margin: 0;
  font-size: 21px;
  font-weight: 600;
  font-family: 'Roboto';
  color: #000;
  align-items: center;
  
  @media (min-width: 1025px) {
    padding-left: 4px;
  }

  @media (min-width: 1921px) {
    margin-bottom: 0;
  }

  .wrapper-icon {
    align-items: center;
    display: flex;
    margin-right: 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Listing = styled.div`
  margin-top: 24px;
`;

export const Blank = styled.div`
  background-color: #FFF;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.21);
`;

export const Button = styled(ButtonAntD)`
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary) {
    &:hover, &:focus, &:active {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const NewButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Label = styled.div`
  color: #7f7f7f;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
`;
